import type {
  DocEntityHandle,
  FloorBayHandle,
  FloorSystemHandle,
  OpeningHandle,
  RoomEdgeHandle,
} from "building-types/handles/docEntityHandleTypes";
import type { GeneratedBuildingEntityHandle } from "building-types/handles/generatedEntityHandleTypes";
import type { WallFramingType } from "building-types/walls/wallFramingTypes";
import type { FloorFramingComponentType } from "./floorFramingComponentTypes";
import type { LumberRail } from "./lumberTypes";

export enum LumberRailMemberInfoSource {
  FLOOR = "FLOOR",
  WALL = "WALL",
}

interface LumberRailMemberInfoBase<
  TSource extends LumberRailMemberInfoSource,
  TMemberType,
  TSourceHandle extends DocEntityHandle,
> {
  readonly source: TSource;
  readonly memberType: TMemberType;
  readonly profileDescriptorName: string; // Name of the profile descriptor. Weneed to have profileDescriptor here
  // but legacy floor and walls don't support this yet.
  readonly sourceHandles?: readonly TSourceHandle[];
}

/** Floor horizontal assembly rail — optional bay source for highlight / context. */
export interface LumberRailMemberInfoFloor
  extends LumberRailMemberInfoBase<
    LumberRailMemberInfoSource.FLOOR,
    FloorFramingComponentType,
    FloorBayHandle | FloorSystemHandle | GeneratedBuildingEntityHandle
  > {}

/** Wall framing rail (studs, plates, headers, etc.). */
export interface LumberRailMemberInfoWall
  extends LumberRailMemberInfoBase<LumberRailMemberInfoSource.WALL, WallFramingType, RoomEdgeHandle | OpeningHandle> {
  /** Present on header members when wall framing meta includes a resolved assembly name. */
  readonly headerAssemblyName?: string;
}

export type LumberRailMemberInfo = LumberRailMemberInfoFloor | LumberRailMemberInfoWall;

export interface LumberMemberInfo {
  readonly rail: LumberRail;
  readonly memberTypeLabel: string;
  readonly profileDescriptorName: string;
  readonly sourceHandles: readonly DocEntityHandle[];
  readonly sourceHandlesTitle: string;
  readonly isWallHeader: boolean;
  readonly headerAssemblyName?: string;
}
